import { take } from "../../util";
import { z } from 'zod';
export const artistLinkSchema = z.object({
    id: z.number().optional(),
    url: z.string().url(),
});
export const fromGql = (item) => take(item, 'id', 'url');
export const fromGqlCollection = (items) => items.map(item => fromGql(item));
//# sourceMappingURL=ArtistLink.js.map